/**
 * Add padding to a number and convert it to string
 * 1 -> "01"
 * 2 -> "02"
 * ...
 * 11 -> "11"
 * 12 -> "12"
 * Useful for dealing with months in query params
 * @param number
 * @returns string
 */
export const pad = (number: number): string => {
  return String(number).padStart(2, "0")
}
